<div class="main-modal-bg">
    <div class="inner-frame-bg inner-frame-desktop">
        <div class="preview-container-desktop">
            <figure class="figure-desktop">
                <svg class="desktop-shell-svg" viewBox="0 0 1520 1100" aria-hidden="true" focusable="false">
                    <!-- 1520 910" -->
                    <defs>
                        <linearGradient id="desktopFrameGlow" gradientTransform="rotate(90)">
                            <stop offset="0%" stop-color="#144496"></stop>
                            <stop offset="55%" stop-color="#2b67c6"></stop>
                            <stop offset="80%" stop-color="#4285f4"></stop>
                            <stop offset="100%" stop-color="#649cfa"></stop>
                          </linearGradient>
                        <radialGradient id="desktopGlassGlow" cx="50%" cy="0%" r="90%">
                            <stop offset="0%" stop-color="#6ea9ff" stop-opacity="0.26"></stop>
                            <stop offset="58%" stop-color="#2d4d95" stop-opacity="0.08"></stop>
                            <stop offset="100%" stop-color="#0b1737" stop-opacity="0"></stop>
                        </radialGradient>
                        <linearGradient id="desktopStandGlow" gradientTransform="rotate(90)">
                            <stop offset="0%" stop-color="#080e1a"></stop>
                            <stop offset="40%" stop-color="#15213b"></stop>
                            <stop offset="45%" stop-color="#192745"></stop>
                            <stop offset="50%" stop-color="#23375e"></stop>
                            <stop offset="60%" stop-color="#516996"></stop>
                            <stop offset="65%" stop-color="#1e2b47"></stop>
                            <stop offset="70%" stop-color="#080e1a"></stop>
                            <stop offset="85%" stop-color="#15213b"></stop>
                            <stop offset="95%" stop-color="#20304f"></stop>
                            <stop offset="100%" stop-color="#5e6980"></stop>
                        </linearGradient>
                        <linearGradient id="desktopLeftStandGlow" gradientTransform="rotate(0)">
                            <stop offset="0%" stop-color="#516996"></stop>
                            <stop offset="55%" stop-color="#15213b"></stop>
                            <stop offset="65%" stop-color="#080e1a"></stop>
                        </linearGradient>
                        <linearGradient id="desktopRightStandGlow" gradientTransform="rotate(0)">
                            <stop offset="0%" stop-color="#080e1a"></stop>
                            <stop offset="30%" stop-color="#15213b"></stop>
                            <stop offset="55%" stop-color="#516996"></stop>
                        </linearGradient>
                        <radialGradient id="desktopStandFloorShadowGradient" cx="50%" cy="50%" r="65%">
                            <stop offset="0%" stop-color="#516996" stop-opacity="0.7"></stop>
                            <stop offset="90%" stop-color="#15213b" stop-opacity="0.4"></stop>
                            <stop offset="100%" stop-color="#080e1a" stop-opacity="0.1"></stop>
                        </radialGradient>
                    </defs>
                    <rect class="desktop-outer" x="0" y="0" width="1520" height="910" rx="20"></rect>
                    <rect class="desktop-outer-highlight" x="5" y="5" width="1496" height="886" rx="20"></rect>
                    <rect class="desktop-screen-border" x="30" y="30" width="1380" height="700" rx="0"></rect>
                    <rect class="desktop-screen-glass" x="30" y="30" width="1380" height="700" rx="0"></rect>
                    <path class="desktop-stand-neck" [attr.d]="standNeckPath"></path>
                    <path class="desktop-stand-neck-glow-left" [attr.d]="standNeckGlowLeftPath"></path>
                    <path class="desktop-stand-neck-glow-right" [attr.d]="standNeckGlowRightPath"></path>
                    
                    <path class="desktop-stand-shadow" [attr.d]="standShadowPath"></path>
                </svg>
                <div class="desktop-content">
                    <iframe allowfullscreen="" frameborder="0" [src]="iframeSrc" class="desktop-iframe" id="desktop-iframe"></iframe>
                </div>
            </figure>
        </div>
    </div>
</div>
